<template>
  <div>
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-auto">
          Web Version
        </div>
        <div class="col-md-auto">
          {{ web_version }}
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-auto">
          API Version
        </div>
        <div class="col-md-auto">
          {{ api_version }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      web_version: "",
      api_version: "",
    };
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage() {
      this.web_version = this.$env.web_version ?? "N/A";

      this.$axios
        .get(`/health`)
        .then(res => {
          this.api_version = res.data.version ?? "N/A";
        })
        .catch(err => {
          this.api_version = "N/A";
          console.log(err);
        });
    },
  },
};
</script>
